const ADMIN_ROOT = "/admin";

const buildAdminRoute = <TPath extends string>(path: TPath) => `${ADMIN_ROOT}/${path}` as const;

export const ADMIN_ROUTE_SEGMENTS = {
  botConfigs: "bot-configs",
  bots: "bots",
  coinSets: "coin-sets",
  productAnalytics: "product-analytics",
  userBots: "users/:userId/bots",
  userDeals: "users/:userId/deals",
  users: "users",
  workers: "workers",
} as const;

export const ROUTES = {
  analytics: "/analytics",
  buyFuel: "/buy-fuel",
  buyFuelPayment: "/buy-fuel/payment",
  dashboard: "/dashboard",
  help: "/help",
  login: "/login",
  profile: "/profile",
  protect: "/protect",
  referral: "/ref/:code",
  register: "/register",
  shortHelp: "/short-help",
  topUps: "/top-ups",
  admin: {
    root: ADMIN_ROOT,
    botConfigs: buildAdminRoute(ADMIN_ROUTE_SEGMENTS.botConfigs),
    bots: buildAdminRoute(ADMIN_ROUTE_SEGMENTS.bots),
    coinSets: buildAdminRoute(ADMIN_ROUTE_SEGMENTS.coinSets),
    productAnalytics: buildAdminRoute(ADMIN_ROUTE_SEGMENTS.productAnalytics),
    users: buildAdminRoute(ADMIN_ROUTE_SEGMENTS.users),
    workers: buildAdminRoute(ADMIN_ROUTE_SEGMENTS.workers),
    userBots: (userId: number) => buildAdminRoute(`users/${userId}/bots`),
    userDeals: (userId: number) => buildAdminRoute(`users/${userId}/deals`),
  },
} as const;
